import React, { Component } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import axios from 'axios';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import themeFile from './util/theme';
import jwtDecode from 'jwt-decode';

import { Provider } from 'react-redux';
import store from './redux/store';
import { SET_AUTHENTICATED } from './redux/types';
import { logoutUser, getUserData } from './redux/actions/userActions';

import Home from './pages/Home';
import Login from './pages/Login';
import AuthRoute from './util/AuthRoute';
import SigninedRoute from './util/SigninedRoute';
import RootRoute from './util/RootRoute';
import './App.css';
import Posts from './pages/Posts';
import PostForm from './components/Manager/Posts/PostForm';
import Staffs from './pages/Staffs';
import PostCategories from './pages/PostCategories';
import PostCategoryForm from './components/Manager/PostCategories/CategoryForm';

const theme = createMuiTheme(themeFile);  

axios.defaults.baseURL = 'https://europe-west1-nteagroup-213216.cloudfunctions.net/api';

const token = localStorage.FBIdToken;
if(token) {
  const decodedToken = jwtDecode(token);
  if(decodedToken.exp * 604800 < Date.now()) {
    store.dispatch(logoutUser())
    window.location.href = '/login'
  } else {
    store.dispatch({ type: SET_AUTHENTICATED});
    axios.defaults.headers.common['Authorization'] = token;
    store.dispatch(getUserData());
  }
}

class App extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <div className="App">
              <Router>
                  <Switch>
                    <SigninedRoute exact path="/" component={Home} />
                    <AuthRoute exact path="/login" component={Login} />
                    <RootRoute exact path="/nhan-su" component={Staffs} />
                    <SigninedRoute exact path="/bai-viet" component={Posts} />
                    <SigninedRoute exact path='/bai-viet/them-moi' component={PostForm} />
                    <SigninedRoute exact path='/bai-viet/chinh-sua/:postId' component={PostForm} />
                    <SigninedRoute exact path="/bai-viet/danh-muc" component={PostCategories} />
                    <SigninedRoute exact path="/bai-viet/danh-muc/them-moi" component={PostCategoryForm} />
                    <SigninedRoute exact path="/bai-viet/danh-muc/chinh-sua/:categoryId" component={PostCategoryForm} />
                  </Switch>
              </Router>
            </div>
        </Provider>
      </MuiThemeProvider>
    );
  }
}

export default App;
